<template>
  <main>
    <Default v-if="questionType === QuestionType.DEFAULT" />
    <DragAndDrop v-else-if="questionType === QuestionType.DRAG_AND_DROP" />
    <TrueOrFalse v-else-if="questionType === QuestionType.TRUE_OR_FALSE" />
    <Gap v-else-if="questionType === QuestionType.FILL_IN_THE_BLANKS" />
  </main>
</template>
<script lang="ts">
import {
  defineComponent,
  onBeforeMount,
  onUnmounted,
  ref,
} from "vue";

import Default from "./Default.vue";
import DragAndDrop from "./DragAndDrop/index.vue";
import Gap from "./Gap/index.vue";
import TrueOrFalse from "./TrueOrFalse.vue";

import { useRouter } from "vue-router";

import { QuestionType, useQuizQuestionsStore } from "@/store/quiz-questions";

export default defineComponent({
  name: "Question",
  components: { Default, DragAndDrop, TrueOrFalse, Gap },
  setup() {
    const storage = JSON.parse(localStorage.getItem("question-type") as string);
    const questionType = ref(QuestionType.DEFAULT);
    const store = useQuizQuestionsStore;
    const router = useRouter();

    function getQuestionType(): void {
       if (storage === null) router.go(-1);

      switch (storage) {
        case QuestionType.TRUE_OR_FALSE:
          questionType.value = QuestionType.TRUE_OR_FALSE;
          break;
        case QuestionType.DRAG_AND_DROP:
          questionType.value = QuestionType.DRAG_AND_DROP;
          break;
        case QuestionType.FILL_IN_THE_BLANKS:
          questionType.value = QuestionType.FILL_IN_THE_BLANKS;
          break;
        default:
          questionType.value = QuestionType.DEFAULT;
          break;
      }
    }

    onBeforeMount(() => {
      getQuestionType();
    });

    onUnmounted(() => {
      store.$reset();
      localStorage.removeItem("question-type");
    });
    return { questionType, QuestionType };
  },
});
</script>
